import BasketItemsSection from 'components/RwdCheckout/Sections/SddSections/BasketItemsSection/BasketItemsSection';
import withGlobalModals from 'hocs/withGlobalModals';
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import AutoReplenishmentEN from 'components/DeliveryInfo/AutoReplenishment/locales/AutoReplenishment_en_US.js';
import AutoReplenishmentFR from 'components/DeliveryInfo/AutoReplenishment/locales/AutoReplenishment_fr_CA.js';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getAutoReplenText = getLocalisedDataFromResource(AutoReplenishmentEN, AutoReplenishmentFR);

const textResources = createStructuredSelector({
    autoReplenish: getTextFromResource(getAutoReplenText, 'autoReplenish'),
    subscriptionFreeShipping: getTextFromResource(getAutoReplenText, 'subscriptionFreeShipping'),
    freeStandardShipping: getTextFromResource(getAutoReplenText, 'freeStandardShipping')
});

const connectedBastketItems = connect(
    createSelector(textResources, texts => {
        return texts;
    })
);

const withConnectedBastkeProps = wrapHOC(connectedBastketItems);

export default withConnectedBastkeProps(withGlobalModals(BasketItemsSection));
